import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CONSTANTS } from 'config/constants';
import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material';

const { TRANSPORT_DEADLINES } = CONSTANTS;

type TransportDeadlineProps = {
    deadline: string | null;
    onDeadlineChange: (deadline: string) => void;
    readOnly: boolean;
};
const TransportDeadline: FC<TransportDeadlineProps> = ({
    deadline,
    onDeadlineChange,
    readOnly,
}: TransportDeadlineProps) => {
    const { t: translate } = useTranslation(['common', 'transport']);
    const [selectedDeadline, setSelectedDeadline] = useState<string | null>(deadline);

    useEffect(() => {
        setSelectedDeadline(deadline);
    }, [deadline]);

    return (
        <FormControl fullWidth>
            <InputLabel id="deadline-label">{translate('transport:DEADLINE')}</InputLabel>
            <Select
                readOnly={readOnly}
                labelId="deadline-label"
                value={selectedDeadline}
                label={translate('transport:DEADLINE')}
                onChange={(event) => {
                    setSelectedDeadline(event.target.value);
                    onDeadlineChange(event.target.value || TRANSPORT_DEADLINES[0]);
                }}
            >
                {TRANSPORT_DEADLINES.map((deadline) => (
                    <MenuItem key={deadline} value={deadline}>
                        {deadline === TRANSPORT_DEADLINES[0] ? translate('transport:NO_DEADLINE') : deadline}
                    </MenuItem>
                ))}
            </Select>
            <FormHelperText>{translate('transport:DEADLINE_HINT')}</FormHelperText>
        </FormControl>
    );
};

export default TransportDeadline;
